import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Logo } from "../components/Logo";
import { Mail, Lock, ArrowRight } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("demo@cashstreak.app");
  const [password, setPassword] = useState("demo1234");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/dashboard");
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-block mb-8" data-testid="login-back-home">
          <Logo size={28} />
        </Link>
        <div className="brut-card p-7 pop-in">
          <h1 className="font-display text-4xl font-black tracking-tight">Welcome back.</h1>
          <p className="mt-1 text-[var(--cs-ink-2)]">Log in to keep your streak alive 🔥</p>

          <form onSubmit={submit} className="mt-7 space-y-4">
            <label className="block">
              <span className="text-xs uppercase tracking-widest font-bold">Email</span>
              <div className="mt-1.5 relative">
                <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--cs-ink-2)]" />
                <input
                  type="email"
                  required
                  data-testid="login-email-input"
                  className="brut-input pl-10"
                  placeholder="you@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </label>
            <label className="block">
              <span className="text-xs uppercase tracking-widest font-bold">Password</span>
              <div className="mt-1.5 relative">
                <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--cs-ink-2)]" />
                <input
                  type="password"
                  required
                  data-testid="login-password-input"
                  className="brut-input pl-10"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </label>

            {err && (
              <div data-testid="login-error" className="brut-card p-3 bg-red-50 text-red-700 text-sm font-semibold" style={{ boxShadow: "3px 3px 0 0 #b91c1c", borderColor: "#b91c1c" }}>
                {err}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-btn"
              className="brut-btn brut-btn-money w-full text-base py-4"
            >
              {loading ? "Signing in..." : "Log in"} <ArrowRight size={18} />
            </button>
          </form>

          <div className="mt-6 text-sm text-[var(--cs-ink-2)]">
            New to CashStreak?{" "}
            <Link to="/signup" className="font-bold underline" data-testid="login-to-signup">
              Create an account
            </Link>
          </div>
          <div className="mt-4 text-xs text-[var(--cs-ink-2)] border-t-2 pt-3" style={{ borderColor: "var(--cs-ink)" }}>
            <strong className="font-bold">Demo:</strong> demo@cashstreak.app / demo1234
          </div>
        </div>
      </div>
    </div>
  );
}
